const exception = require('../exception/index.js');

let ary_no_dup_action = {
    /*
        "action_name":{
            handlers:[
                ()=>{
                    // 何を制御するかはハンドラの実装者にゆだねる
                    // テンプレ的なコードになる場合は、コードジェネーターで対処
                }
            ],
            disabled:false
        }
    
        ※ エントリの追加ルーチンが必要な箇所が２つ以上に増えるまではエントリ追加関数は用意しない。
        ※ ただし、いつでも分離できるようには準備をする。
    */

}


/**
 * アクションに紐づいたハンドラを全て実行
 * @param {*} ary_action - 連想配列`ary_no_dup_action`の要素の一つ、呼び出し元から与えられる
 * @param {*} action_enable アクション有効化時はtrue,無効化時はfalse
 */
const run_all_handler = (ary_action,action_enable) => {
    for(let handler of ary_action.ary_handler){
        handler(action_enable);
    }
}



module.exports = {
    regist_action:(action_name)=>{
        ary_no_dup_action[action_name]={
            ary_handler:[],
            disabled:false,
        }
    },
    /**
     * ハンドラの追加
     * @param {*} handler - ハンドラまたはハンドラの配列
     */
    regist_handler:(action_name,handler_or_array)=>{
        let maybe_function = handler_or_array;
        let maybe_array = handler_or_array; 
        if(maybe_function && typeof maybe_function === 'function'){
            ary_no_dup_action[action_name].ary_handler.push(maybe_function);
            
        } else if(Array.isArray(maybe_array)) {
            if(maybe_array.every(e=> e && console.log(e) && typeof e === 'function') === false){
                throw new exception.InvalidParameter('nodup_action::regist_handler : Array must be array of handler.');
            } 
            // TODO:push.applyの用法はメモにしておく
            // objectの{...a,...b}と対になる用法のはず。
            ary_no_dup_action[action_name].ary_handler.push.apply(ary_no_dup_action[action_name].ary_handler,maybe_array);
        }
        
    },
    is_action_enabled:(action_name)=>{
        return (!ary_no_dup_action[action_name].disabled);
    },
    is_action_disabled:(action_name)=>{
        return (ary_no_dup_action[action_name].disabled);
    },
    disable_action:(action_name)=>{
        let ary_action = ary_no_dup_action[action_name];
        ary_no_dup_action[action_name].disabled = true;
        run_all_handler(ary_action,false);
    },
    enable_action:(action_name)=>{
        let ary_action = ary_no_dup_action[action_name];
        ary_no_dup_action[action_name].disabled = false;
        run_all_handler(ary_action,true);
    },

    /**
     * 標準ハンドラの生成を行うジェネレーター
     * @param {string} option.selector_element_for_action - cssセレクタで、ビジー表示を行いたい要素を指定する。
     * @param {string} option.handler_name - 生成したハンドラの名前（エラーメッセージのため、他のハンドラと重複しないように指定する）
     * @desc
     * register_handler()の呼び出しに使える標準ハンドラを生成できる。
     * ハンドラの動作のため、selectorで指定した要素は、次のことを満たすようマークアップされる必要がある。
     * * data-nodup-retract-html属性を持たない
     * * data-nodup-busy-html属性に必要なマークアップが指定されている
     * 
     */
    generic_handler:(option={}) => {

        //ビジー表示を行う要素の規定
        const { selector_element_for_action,handler_name } = option;
    
        return (action_enable)=>{
        
            const DOM_element_for_action = document.querySelector(selector_element_for_action);
        
            let busy_html;
            let retract_html;
            let current_html;
            let retracted_already;
        
            if('nodupBusyHtml' in DOM_element_for_action.dataset){
                busy_html = DOM_element_for_action.dataset['nodupBusyHtml'];
            } else {
                throw new exception.MalformedMarkup(`${handler_name} : [Markup is broken] no busy html markup in element selected by "${selector_element_for_action}" `);
            }
        
            //その他準備
            
            if(action_enable){
                console.log(`action enabled: ${handler_name}`);
                retract_html = DOM_element_for_action.dataset['nodupRetractHtml'];
                DOM_element_for_action.classList.remove('action-temporary-disabled');
                DOM_element_for_action.innerHTML = retract_html;
                delete DOM_element_for_action.dataset['nodupRetractHtml'];
            } else {
                // 多重退避させてしまうと元のマークアップを消失してしまうので
                // ここで多重退避しないようにチェックをする。
                retracted_already = 'nodupRetractHtml' in DOM_element_for_action.dataset;
                if(retracted_already) return;
                current_html = DOM_element_for_action.innerHTML;
                DOM_element_for_action.dataset['nodupRetractHtml'] = current_html;
                DOM_element_for_action.innerHTML = busy_html;
                DOM_element_for_action.classList.add('action-temporary-disabled');
                console.log(`action disabled: ${handler_name}`);
            }
    
        };
    
    }

}


/**
 * handler_sample
 * 関数`regist_handler`に与えるハンドラのサンプル

 * @param {string} action_enable - trueの場合にビジー状態の解除、falseの場合にビジー状態の有効化を行う。
 * 
 * ## ハンドラの役目
 * 1. 次の手段をもって、ビジー表示を行う要素を規定する。
 *      * document.querySelector()他
 *      * 状況によって複数要素をビジーにしないといけない場合があるので、ハンドラの実装者にゆだねる方式を採用
 * 2. 1.で規定した要素を操作してビジー表示を行う
 *      * この時datasetなどを使って、内部html他、既存内容の保存をする。
 *          * すでに保存済みの場合は処理を中断する必要があるので、保存処理を工夫して判定を可能にしておくこと。
 *          * 特に複数要素をビジーにする場合は注意：状態が通常時とビジー時で混在する可能性がある。
 */



const handler_sample = (action_enable)=>{

    //ここは関数名と同じにする
    const handler_name="handler_sample";

    //ビジー表示を行う要素の規定
    const selector_element_for_action='#form form .button.cta';
    const DOM_element_for_action = document.querySelector(selector_element_for_action);

    let busy_html;
    let retract_html;
    let current_html;
    let retracted_already;

    if('nodupBusyHtml' in DOM_element_for_action.dataset){
        busy_html = DOM_element_for_action.dataset['nodupBusyHtml'];
    } else {
        throw new exception.MalformedMarkup(`${handler_name} : [Markup is broken] no busy html markup in element selected by "${selector_element_for_action}" `);
    }

    //その他準備
    
    if(action_enable){
        retract_html = DOM_element_for_action.dataset['nodupRetractHtml'];
        DOM_element_for_action.innerHTML = retract_html;
        delete DOM_element_for_action.dataset['nodupRetractHtml'];
    } else {
        // 多重退避させてしまうと元のマークアップを消失してしまうので
        // ここで多重退避しないようにチェックをする。
        retracted_already = 'nodupRetractHtml' in DOM_element_for_action.dataset;
        if(retracted_already) return;
        current_html = DOM_element_for_action.innerHTML;
        DOM_element_for_action.dataset['nodupRetractHtml'] = current_html;
        DOM_element_for_action.innerHTML = busy_html;
    }

}

